<h2 class="g-card-title">Risk</h2>

<ng-container *ngIf="loading == false && data && data.length != 0; else elseBlockRisk">
    <div class="al-grid grid-2-inner" *ngFor="let r of data">
        <span class="g-text-title">{{ r.riskCategory }}</span>

        <span class="g-text-content" *ngIf="!r.alert; else isRisk">{{ formatRisk(r) }}</span>
        <ng-template #isRisk>
            <span class="g-text-content" style="color: red">{{ formatRisk(r) }}</span>
        </ng-template>
    </div>
</ng-container>

<ng-template #elseBlockRisk>
    <div *ngIf="loading; else notLoadingNoData">
        <spin-loader></spin-loader>
    </div>

    <ng-template #notLoadingNoData>
        <no-data-screen [noDataType]="noDataSelection"></no-data-screen>
    </ng-template>
</ng-template>
